module.exports = (s) => [
  {
    name: '姓名',
    value: 'name',
  },
  {
    name: '账号角色',
    value: 'roles',
    format: row => Array.isArray(row.roles) ? row.roles.join('、') : row.roles,
  },
  {
    name: '状态',
    value: 'status',
    width: 80,
    format: row => s.$createElement(
      'span',
      {
        style: { color: Number(row.status) === 1 ? '' : '#F56C6C' },
      },
      Number(row.status) === 1 ? '正常' : '过期'
    ),
  },
  {
    name: '操作',
    fixed: 'right',
    width: 300,
    format: (row) => {
      const h = s.$createElement;
      return h('div', null, [
        h('el-button', {
          props: { type: 'primary', size: 'mini' },
          on: { click: () => s.showEditBox({ row }) },
        }, '修改'),
        h('el-button', {
          props: { type: 'primary', size: 'mini' },
          on: { click: () => s.showEditAdvertiserBox({ row }) },
        }, '修改可操作广告主'),
        h('el-button', {
          props: { type: 'warning', size: 'mini' },
          on: { click: () => s.showResetBox({ row }) },
        }, '重置密码'),
      ]);
    },
  },
];
